module.exports = __webpack_public_path__ + "static/media/fleetprocure--main.e540d1d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/fleetprocure/fleetprocure--main.jpg
// module id = 165
// module chunks = 0